webpackJsonp([1,2],Array(37).concat([
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(79);





var axio = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: window.location.protocol + '//' + window.location.hostname + '/api/v17'
});

var dev = {};

if (false) {
  axio = axios.create({
    baseURL: window.location.protocol + '//' + window.location.hostname + ':3001/api/v17'
  });

  dev = {
    events: {
      index: function index() {
        return new _Promise(function (res, rej) {
          return res({
            data: [].concat(_toConsumableArray(data), _toConsumableArray(data.reverse()), _toConsumableArray(data.reverse()))
          });
        });
      },

      show: function show(link) {
        return new _Promise(function (res, rej) {
          return res({ data: data.find(function (e) {
              return e.link === link;
            }) || {} });
        });
      },

      create: function create(event, pass) {
        return new _Promise(function (res, rej) {
          return res(data.push(event));
        });
      }
    }
  };
}

var prod = {
  events: {
    index: function index() {
      return axio.get('/events');
    },
    show: function show(link) {
      return axio.get('/events/' + link);
    },
    create: function create(event, pass) {
      return axio.post('/events', { event: event, pass: pass });
    }
  }
};

var api = window.api = {};

if (true) {
  api = prod;
}

if (false) {
  (function () {
    axio.defaults.timeout = 400;

    var switchTo = function switchTo(type) {
      for (var resource in api) {
        for (var method in api[resource]) {
          api[resource][method] = type[resource][method];
        }
      }
    };

    var _loop = function _loop(res) {
      var proxy = {};

      var _loop2 = function _loop2(method) {
        proxy[method] = function () {
          var _prod$res;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return (_prod$res = prod[res])[method].apply(_prod$res, args).then(function (res) {
            switchTo(prod);
            console.warn('Backend API server responds, fallback is removed.');
            return res;
          }).catch(function (_) {
            var _dev$res;

            switchTo(dev);
            console.warn('Backend API server doesn\'t respond. ' + 'Fallback with data.js content is used.');
            return (_dev$res = dev[res])[method].apply(_dev$res, args);
          });
        };
      };

      for (var method in prod[res]) {
        _loop2(method);
      }

      api[res] = proxy;
    };

    for (var res in prod) {
      _loop(res);
    }
  })();
}

window.api = api;

/* harmony default export */ __webpack_exports__["a"] = api;

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date__ = __webpack_require__(39);





var store = window.store = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  data: { now: new Date(2017, 2, 30), raw_events: null },
  methods: {
    fetchAll: function fetchAll() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].events.index().then(function (res) {
        _this.raw_events = res.data;
      });
    },
    fetchOnly: function fetchOnly(link) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].events.show(link).then(function (res) {
        if (_this2.raw_events === null) _this2.raw_events = [];
        var idx = _this2.raw_events.findIndex(function (e) {
          return e.link === link;
        });

        idx === -1 ? _this2.raw_events.push(res.data) : _this2.$set(_this2.raw_events, idx, res.data);
      });
    }
  },
  computed: {
    events: function events() {
      var _this3 = this;

      if (this.raw_events === null) return null;

      return this.raw_events.map(function (e) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_date__["a" /* default */])(e.date, _this3.now));
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

var extractAll = function extractAll(date, now) {
  var res = { year: 0, month: 0, day: 0, isOutdated: false };

  var matched = /^(\d\d\d?\d?)[.|-](\d\d?)[.|-](\d\d?)$/.exec(date);
  if (!matched) res;

  var _matched = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(matched, 4),
      _ = _matched[0],
      y = _matched[1],
      m = _matched[2],
      d = _matched[3];

  res.day = d = +d;
  res.year = y = +y;
  res.month = m = +m;

  var ny = now.getFullYear(),
      nm = now.getMonth() + 1,
      nd = now.getDate();

  res.isOutdated = y < ny || y === ny && m < nm || y === ny && m === nm && d < nd;

  return res;
};

/* harmony default export */ __webpack_exports__["a"] = extractAll;

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)
__webpack_require__(146)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-e37d5f62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)
__webpack_require__(138)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-2144fe2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-abed001a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-674a23a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  "data-v-07cb9a7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_event__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_about__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_main__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_new__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_new__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);






/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/new',
    name: 'new',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_new___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_about___default.a
  }, {
    path: '/:id',
    name: 'event',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_event___default.a
  }, {
    path: '/',
    name: 'main',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_main___default.a
  }]
});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)
__webpack_require__(134)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  "data-v-149b6829",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = [{
  theme: 'orange',
  link: 'detecting-people-in-video',
  title: 'Детектирование и трекинг людей на видеоряде',
  date: '2017-03-20',
  time: '17:30',
  annotation: '\n        \u041D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u043D\u0430\u0435\u0442, \u0447\u0442\u043E \u0442\u0430\u043C \u0440\u0430\u0441\u0441\u043A\u0430\u0436\u0443\u0442, \u043D\u043E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u0435 \u2014\n        \u0430\u043D\u0430\u043B\u0438\u0437 \u0432\u0438\u0434\u0435\u043E \u043E\u0447\u0435\u043D\u044C \u0432\u043E\u0441\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D \u0441\u0435\u0433\u043E\u0434\u043D\u044F.\n      '
}, {
  theme: 'blue',
  link: 'data-science-meetup',
  title: 'Data Science Meetup',
  date: '2017-03-04',
  time: '16:00',
  annotation: '\n          \u0412\u0441\u0435\u0433\u043E \u0431\u0443\u0434\u0435\u0442 \u0447\u0435\u0442\u044B\u0440\u0435 \u0434\u043E\u043A\u043B\u0430\u0434\u0430, \u043E\u0434\u0438\u043D \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0434\u043B\u044F \u043D\u043E\u0432\u0438\u0447\u043A\u043E\u0432,\n          \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0442\u0443\u0441\u0430 \u043C\u0435\u0445\u043C\u0430\u0442\u0430 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0442\u0430\u043C.\n          \u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435: <a href="http://vk.com/dsmt61">vk.com/dsmt61</a>.\n        '
}, {
  link: 'speech-recognition-with-HMM',
  theme: 'green',
  title: 'Распознавание речи на основе скрытых марковских моделей',
  date: '2017-02-20',
  time: '17:30',
  place: '212',
  annotation: '\n        \u0414\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A \u0440\u0430\u0441\u0441\u043A\u0430\u0436\u0435\u0442 \u043E \u0421\u041C\u041C, \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u0445 \u0432 \u0440\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0438 \u0440\u0435\u0447\u0438,\n        \u0438 \u043E \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u043C\u0438 \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441.\n      ',
  text: '\n          \u041C\u044B \u043E\u0431\u0441\u0443\u0434\u0438\u043B\u0438 \u0430\u043B\u0433\u043E\u0440\u0438\u0442\u043C\u044B \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044F \u0421\u041C\u041C \u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u0432 \u0440\u0430\u0441\u043F\u043E\u0437\u043D\u0430\u0432\u0430\u043D\u0438\u0438 \u0440\u0435\u0447\u0438.\n          \u041F\u043E\u0447\u0442\u0438 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0431\u044B\u043B\u043E \u043F\u043E\u043D\u044F\u0442\u043D\u043E, \u043D\u043E \u0437\u0430\u0442\u043E \u043C\u044B \u043D\u0430\u043F\u0438\u0441\u0430\u043B\u0438 \u043A\u0440\u0430\u0441\u0438\u0432\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435-\u043E\u0434\u043D\u043E\u0441\u0442\u0440\u043E\u0447\u043D\u0438\u043A,\n          \u0442\u0430\u043A \u0447\u0442\u043E \u0442\u0435\u043F\u0435\u0440\u044C \u043C\u043E\u0436\u043D\u043E \u0441\u043C\u0435\u043B\u043E \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C \u0437\u0430\u043D\u0438\u043C\u0430\u0442\u044C\u0441\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C\u044E.\n\n          <a href="http://forum.mmcs.sfedu.ru/t/seminar-ko-kompyuternomu-zreniyu-i-obrabotke-izobrazhenij/678/56">\n            \u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u043A \u0441\u0435\u043C\u0438\u043D\u0430\u0440\u0443</a>.\n\n          <div class="img" style="background-image: url(https://pbs.twimg.com/media/C5H9B0MWIAMtcSa.jpg:large)"></div>\n          <div style="text-align:center"><i>\u0442\u043E \u0441\u0430\u043C\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435</i></div>\n        ',
  authors: [{ name: 'Дмитрий Свиридкин', ava: 'https://pbs.twimg.com/profile_images/826897257689649154/JWf5zVTT.jpg' }]
}, {
  link: '47hours',
  theme: 'violet',
  title: 'VR & AR хакатон',
  date: '2017-04-02',
  time: '16:30',
  place: '311',
  annotation: '\u042D\u0442\u043E \u0441\u0443\u043F\u0435\u0440 \u043A\u0440\u0443\u0442\u043E\u0439 \u0445\u0430\u043A\u0430\u0442\u043E\u043D \u043D\u0430 47 \u0447\u0430\u0441\u043E\u0432.<br>\u041D\u043E \u0435\u0441\u0442\u044C \u043E\u0434\u0438\u043D \u043C\u0438\u043D\u0443\u0441: \u043E\u043D \u0432 \u0422\u0430\u0433\u0430\u043D\u0440\u043E\u0433\u0435.'
}, {
  link: 'cat',
  theme: 'gray',
  title: 'Теория Категорий',
  date: '2017-4-28',
  time: '16:30',
  place: '311',
  annotation: '\n          \u041A\u0443\u0440\u0441 \u043F\u043E\u0441\u0432\u044F\u0449\u0451\u043D <a href="#">\u0430\u0431\u0441\u0442\u0440\u0430\u043A\u0442\u043D\u043E\u0439 \u0444\u0438\u0433\u043D\u0435</a>, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u043D\u0438\u043A\u0442\u043E \u043D\u0438\u043A\u0430\u043A \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0439 \u0436\u0438\u0437\u043D\u0438.\n          \u0411\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0435\u0437\u043D\u043E, \u043D\u043E \u044D\u0442\u043E \u043D\u0435 \u0442\u043E\u0447\u043D\u043E.\n        ',
  text: '\n          <img style="height:100px;margin-right:0.8em;float:left" src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Commutative_diagram_for_morphism.svg/200px-Commutative_diagram_for_morphism.svg.png"/>\n          \u041C\u044B \u043E\u0431\u0437\u043E\u0440\u043D\u043E \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0438\u043C \u0440\u0430\u0437\u0434\u0435\u043B \u043C\u0430\u0442\u0435\u043C\u0430\u0442\u0438\u043A\u0438, \u0438\u0437\u0443\u0447\u0430\u044E\u0449\u0438\u0439 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0439\n          \u043C\u0435\u0436\u0434\u0443 \u043C\u0430\u0442\u0435\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u0437\u0430\u0432\u0438\u0441\u044F\u0442 \u043E\u0442 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B\n          \u044D\u0442\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432.\n\n          \u0422\u0435\u043E\u0440\u0438\u044F \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0439 \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0432 \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u043C\u0430\u0442\u0435\u043C\u0430\u0442\u0438\u043A\u0435, \u043E\u043D\u0430 \u0442\u0430\u043A\u0436\u0435\n          \u043D\u0430\u0448\u043B\u0430 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u043A\u0435, \u043B\u043E\u0433\u0438\u043A\u0435 \u0438 \u0432 \u0442\u0435\u043E\u0440\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0444\u0438\u0437\u0438\u043A\u0435. \u041E\u0431\u0449\u0435\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0439\u043D\u044B\u0435\n          \u043F\u043E\u043D\u044F\u0442\u0438\u044F \u0442\u0430\u043A\u0436\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0432 \u044F\u0437\u044B\u043A\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F <i>Haskell</i>.\n\n          <h6 style="margin:0;padding:0;font-size:1em">\u041A\u0443\u0440\u0441 \u043E\u043F\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0434\u0432\u0435 \u043A\u043D\u0438\u0433\u0438:</h6>\n          <ul style="margin: 0.5em 0 0;display:inline-block">\n            <li>Category Theory (by Steve Awodey)</li>\n            <li>Category Theory (by Steve Awodey)</li>\n          </ul>\n\n          \u0415\u0441\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u0441\u0434\u0430\u0432\u0430\u0442\u044C \u0437\u0430\u0447\u0451\u0442 \u0438\u043B\u0438 \u044D\u043A\u0437\u0430\u043C\u0435\u043D (\u043F\u043E&nbsp;\u0436\u0435\u043B\u0430\u043D\u0438\u044E \u0441\u043B\u0443\u0448\u0430\u0442\u0435\u043B\u044F).\n          \u0414\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043A\u0430\u043D\u0430\u0442.\n        ',
  authors: [{
    name: 'Виталий Брагилевский',
    ava: 'http://compsciclub.ru/media/cache/eb/74/eb744370ecdcc277036c108e12cc8794.jpg'
  }, {
    name: 'Денис Загумённов',
    ava: 'https://pbs.twimg.com/profile_images/2586456123/0msx978pkihz2xo7k9hu.jpeg'
  }],
  attendees: [{
    name: 'Артём Пеленицын',
    ava: 'https://pbs.twimg.com/profile_images/393613739/________bigger.jpg'
  }, {
    name: 'Денис Мирзоев',
    ava: 'https://pbs.twimg.com/profile_images/560171941974126592/nZ-zs_8a_bigger.jpeg'
  }, {
    name: 'Всеволод Квачёв',
    ava: 'https://pbs.twimg.com/profile_images/703992223629709312/HfB1HT-Q_bigger.jpg'
  }, {
    name: 'Георгий Лукьянов',
    ava: 'https://pbs.twimg.com/profile_images/757847164403851268/Ur4cy0Da_bigger.jpg'
  }, {
    name: 'Яна Демьяненко',
    ava: 'https://pbs.twimg.com/profile_images/526408711594467328/6KJyezCR_bigger.png'
  }, {
    name: 'Илья Варламов',
    ava: 'https://pbs.twimg.com/profile_images/591502306971004928/5LKyq1_L_bigger.jpg'
  }, {
    name: 'Анатолий Прилютский',
    ava: 'https://pbs.twimg.com/profile_images/694436245527724032/atNM2g1P_bigger.jpg'
  }, {
    name: 'Бартош Милевский',
    ava: 'https://pbs.twimg.com/profile_images/1000136690/IslandBartosz_bigger.JPG'
  }, {
    name: 'Дмитрий Свиридкин',
    ava: 'https://pbs.twimg.com/profile_images/838796547999612928/-vm0f_xL_bigger.jpg'
  }, {
    name: 'Илья Мурадьян',
    ava: 'https://pbs.twimg.com/profile_images/729375035631218688/pI2h_8-p_bigger.jpg'
  }, {
    name: 'Тихон Белоушко',
    ava: 'https://pbs.twimg.com/profile_images/721417643903827968/RJkOcK0X_bigger.jpg'
  }, {
    name: 'Роман Чепляка',
    ava: 'https://pbs.twimg.com/profile_images/458731352758579200/TSideAqh_bigger.jpeg'
  }, {
    name: 'Александр',
    ava: 'https://pbs.twimg.com/profile_images/823859625112039425/z6Q8kq20_bigger.jpg'
  }, {
    name: 'Михаил Бочкарёв',
    ava: 'https://pbs.twimg.com/profile_images/823334889521106944/RTOq0xfV_bigger.jpg'
  }, {
    name: 'Алексей Головешкин',
    ava: 'https://pbs.twimg.com/profile_images/378800000746137548/5039255f3a222c2a89c0598fc6e4fbd9_bigger.jpeg'
  }, {
    name: 'Евгений Пшеничный',
    ava: 'https://pbs.twimg.com/profile_images/691216526981070848/DSM41MZ__bigger.jpg'
  }, {
    name: 'Андрей Руденец',
    ava: 'https://pbs.twimg.com/profile_images/792065837582671872/pkibPV44_bigger.jpg'
  }]
}, {
  link: 'hello-from-northeastern-university',
  theme: 'yellow',
  title: 'Ulysses возвращается!',
  date: '2017-03-31',
  time: '15:30',
  annotation: '\n        \u041F\u043E\u0433\u043E\u0432\u043E\u0440\u0438\u043C \u043E \u0442\u043E\u043C, \u043A\u0430\u043A\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u0440\u0435\u0448\u0430\u044E\u0442\u0441\u044F \u0432 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u0438\u0438 \u044F\u0437\u044B\u043A\u043E\u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0432 Northeastern University.\n      ',
  authors: [{
    name: 'Артём Пеленицын',
    ava: 'https://pbs.twimg.com/profile_images/393613739/________bigger.jpg'
  }]
}];

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  computed: {
    atMain: function atMain() {
      return this.$route.name === 'main';
    }
  }
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_title__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parts_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_content__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_authors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_authors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_authors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_attendees__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_attendees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__parts_attendees__);







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'extended-event',
  components: { eTitle: __WEBPACK_IMPORTED_MODULE_0__parts_title___default.a, eContent: __WEBPACK_IMPORTED_MODULE_1__parts_content___default.a, eAuthors: __WEBPACK_IMPORTED_MODULE_2__parts_authors___default.a, eAttendees: __WEBPACK_IMPORTED_MODULE_3__parts_attendees___default.a },
  props: { e: { required: true }, header: { default: true } },
  computed: {
    text: function text() {
      var source = this.e.text || this.e.annotation || '';
      return source.trim().replace(/\s*\n\s*\n\s*/g, '<br><br>');
    }
  }
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_title__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parts_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parts_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_authors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_authors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__parts_authors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_content__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__parts_content__);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'event',
  props: ['e', 'no-time'],
  components: { eTitle: __WEBPACK_IMPORTED_MODULE_0__parts_title___default.a, eAuthors: __WEBPACK_IMPORTED_MODULE_1__parts_authors___default.a, eContent: __WEBPACK_IMPORTED_MODULE_2__parts_content___default.a },
  computed: {
    compactly: function compactly() {
      return !this.e.authors;
    },
    hasContent: function hasContent() {
      return this.e.text || this.e.annotation;
    }
  }
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'e-attendees',
  props: ['attendees'],
  data: function data() {
    return {
      expand: false
    };
  },
  methods: {
    url: function url(src) {
      return 'url(' + src + ')';
    }
  },
  computed: {
    all: function all() {
      var a = this.attendees.slice(0, this.attendees.length);

      for (var i = a.length; i; i--) {
        var j = Math.floor(Math.random() * i);
        var x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }

      return a;
    },
    left: function left() {
      return this.all.slice(0, 7);
    },
    rightCount: function rightCount() {
      return Math.max(0, this.attendees.length - 7);
    }
  }
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'e-authors',
  props: ['authors'],
  methods: {
    url: function url(src) {
      return 'url(' + src + ')';
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'e-content',
  props: ['text', 'crop'],
  data: function data() {
    return { expanded: false };
  },

  methods: {
    toggleText: function toggleText() {
      this.expanded = !this.expanded;
    }
  },

  computed: {
    offerMoreText: function offerMoreText() {
      return this.crop && this.text && !this.expanded;
    }
  }
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'e-title',
  props: ['e', 'no-time', 'extended'],
  computed: {
    fullDate: function fullDate() {
      var months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

      var t = new Date();
      var isToday = this.e.year === t.getFullYear() && this.e.month === t.getMonth() + 1 && this.e.day === t.getDate();

      var date = isToday ? 'сегодня в' : this.e.day + ' ' + months[this.e.month - 1];
      var time = '' + (this.noTime ? '' : this.e.time || '');
      return date + ' ' + time;
    },
    dateAndPlace: function dateAndPlace() {
      var p = this.e.place;
      p = p && p.length && this.extended ? ', \xA0\u0430\u0443\u0434. ' + p : '';

      return this.fullDate + p;
    }
  }
};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'about-page',

  data: function data() {
    return {
      contacts: [{
        name: 'Игорь Стребежев',
        about: 'разработчик и модератор',
        vk: 'https://vk.com/strebz',
        email: {
          key: '01iqeHr_Fxn8kukwxs4T6Q4A',
          token: '8TvGhTGjFwnDEnl3twqjWJidqylH0_L9jxry-3-I3YU'
        }
      }, {
        name: 'Яна Демяненко',
        about: 'ответственная за сайт',
        vk: 'https://vk.com/id297003875',
        email: {
          key: '01NwdxQLAH4bVYVgSxQydqhA',
          token: 'jBX5Vm0ShMmNNmvtydg7XYBKqLWMyddZrJRkxs4vyNM'
        }
      }]
    };
  },

  computed: {
    emails: function emails() {
      var google = 'http://www.google.com/recaptcha/mailhide/d?';
      return this.contacts.map(function (p) {
        return {
          href: google + 'k=' + p.email.key + '==&amp;c=' + p.email.token + '=',
          click: 'window.open(\'' + google + 'k=' + p.email.key + '==&c=' + p.email.token + '=\', \'\', \'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=500,height=300\');return !1'
        };
      });
    }
  }

};

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_event_extended__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_event_extended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_event_extended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(38);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'event-page',
  components: { event: __WEBPACK_IMPORTED_MODULE_0__components_event_extended___default.a },
  computed: {
    events: function events() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].events || [];
    },
    e: function e() {
      var _this = this;

      return this.events.find(function (e) {
        return e.link === _this.$route.params.id;
      }) || { theme: '' };
    }
  },
  watch: {
    'e.theme': function eTheme() {
      this.$root.theme = this.e.theme;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].fetchOnly(this.$route.params.id);
    this.$root.theme = this.e.theme;
  }
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_event_index__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_event_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_event_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(38);





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'main-page',
  components: { Event: __WEBPACK_IMPORTED_MODULE_0__components_event_index___default.a },
  computed: {
    loaded: function loaded() {
      return !!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].events;
    },
    events: function events() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].events || [];
    },
    upcoming: function upcoming() {
      return this.events.filter(function (e) {
        return !e.isOutdated;
      });
    },
    outdated: function outdated() {
      return this.events.filter(function (e) {
        return e.isOutdated;
      });
    }
  },
  methods: {},
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].fetchAll();
  }
};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_api__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_event__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_event_extended__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_event_extended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_event_extended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_date__ = __webpack_require__(39);



var _this = this;







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'add-new-page',
  components: { event: __WEBPACK_IMPORTED_MODULE_3__components_event___default.a, extended: __WEBPACK_IMPORTED_MODULE_4__components_event_extended___default.a },

  data: function data() {
    return {
      pass: '',
      s: { title: '', anno: '', theme: '', url: '', text: '', place: '', time: '', date: _this.today },
      p: {
        title: 'Коротко и понятно, чтобы хотелось прийти',

        anno: '\n        \u041D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u043D\u0430\u0435\u0442, \u0447\u0442\u043E \u0442\u0430\u043C \u0440\u0430\u0441\u0441\u043A\u0430\u0436\u0443\u0442, \u043D\u043E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u0435 \u2014\n        \u0442\u0435\u043C\u0430 \u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0431\u0435\u0448\u0435\u043D\u043D\u043E\u0439 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u044C\u044E.\n      '.replace(/\s+/g, ' ').trim(),

        text: '\n        \u0417\u0434\u0435\u0441\u044C \u043C\u043E\u0436\u043D\u043E \u043F\u0438\u0441\u0430\u0442\u044C \u043E\u0431\u044B\u0447\u043D\u044B\u0439 <i>html</i>, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E,\n        <span style="color: #e91e63">\u0441\u043E \u0441\u0442\u0438\u043B\u044F\u043C\u0438</span>.\n        \u0425\u043E\u0440\u043E\u0448\u0438\u0439 \u043F\u0440\u0438\u043C\u0435\u0440 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0441\u0442\u0430 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0439\u0442\u0438\n        <a href="/cat">\u0437\u0434\u0435\u0441\u044C</a>.\n\n        \u0412 \u0431\u0443\u0434\u0443\u0449\u0435\u043C, \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C markdown \u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0443.\n      '.split(/\s[\r\t\v\f ]+/).join('\n').replace(/(.)\n(?!\n)/g, '$1 ').trim()
      }
    };
  },

  created: function created() {
    var d = new Date();
    var addZero = function addZero(v) {
      return (v < 10 ? '0' : '') + v;
    };

    var _map = [d.getMonth() + 1, d.getDate(), d.getHours(), d.getMinutes()].map(addZero),
        _map2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_map, 4),
        mo = _map2[0],
        da = _map2[1],
        ho = _map2[2],
        mi = _map2[3];

    this.s.date = d.getFullYear() + '-' + mo + '-' + da;
    this.s.time = ho + ':' + mi;
  },


  watch: {
    text: function text() {
      if (this.$root.$el.offsetWidth < 500) return;
      this.$refs.text.style.height = this.$refs.preview.$el.offsetHeight + 'px';
    }
  },

  computed: {
    event: function event() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: this.s.title || this.p.title,
        annotation: this.s.anno || this.p.anno,
        text: this.s.text || this.p.text,
        date: this.s.date,
        time: this.s.time,
        link: this.link,
        theme: this.s.theme
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["a" /* default */])(this.s.date, new Date()));
    },
    link: function link() {
      var phrase = this.s.url || this.s.title || this.p.title;
      return phrase.split(' ').join('-').toLowerCase();
    }
  },

  methods: {
    create: function create() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__store_api__["a" /* default */].events.create(this.event, this.pass).then(function (_) {
        return _this2.$router.push({ name: 'main' });
      });
    }
  }
};

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-c100fd38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-59abb411",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  "data-v-a93696c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  "data-v-173aec36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-54c923a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.extended) ? _c('router-link', {
    attrs: {
      "to": _vm.e.link
    },
    domProps: {
      "textContent": _vm._s(_vm.e.title)
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.e.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "date",
    domProps: {
      "textContent": _vm._s(_vm.dateAndPlace)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [!_vm.atMain && _vm.$root.theme],
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": _vm.atMain ? 'span' : 'a'
    },
    domProps: {
      "textContent": _vm._s('mmcs meetups')
    }
  })], 1), _vm._v(" "), _c('small', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'new'
      }
    },
    domProps: {
      "textContent": _vm._s('Администраторам')
    }
  }), _vm._v(" "), _c('s', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Статистика")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    },
    domProps: {
      "textContent": _vm._s('О сайте')
    }
  })], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.upcoming) ? _c('section', {
    staticClass: "news"
  }, _vm._l((_vm.upcoming), function(event) {
    return _c('event', {
      attrs: {
        "e": event
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('section', {
    staticClass: "more"
  }, [_vm._v("\n    " + _vm._s(_vm.upcoming.length ? 'Ещё' : 'Никаких') + "\n    митапов не предвидится, но ты можешь\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'new'
      }
    }
  }, [_vm._v("организовать свой")]), _vm._v("\n    или попробовать\n    "), _c('a', {
    staticStyle: {
      "color": "#5fbc5f"
    },
    attrs: {
      "href": "https://stepik.org"
    }
  }, [_vm._v("пройти курс на степике")]), _vm._v(".\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.outdated) ? _c('section', {
    staticClass: "outdated"
  }, _vm._l((_vm.outdated), function(event) {
    return _c('event', {
      attrs: {
        "e": event,
        "no-time": true
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [_vm.e.theme, {
      compactly: _vm.compactly
    }]
  }, [_c('header', [_c('e-title', {
    attrs: {
      "e": _vm.e,
      "extended": false,
      "no-time": _vm.noTime
    }
  })], 1), _vm._v(" "), (_vm.hasContent) ? _c('e-content', {
    attrs: {
      "text": _vm.e.annotation
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "page",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('label', [_vm._v("\n          Название\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.title),
      expression: "s.title"
    }],
    attrs: {
      "type": "text",
      "maxlength": "60",
      "placeholder": _vm.p.title
    },
    domProps: {
      "value": _vm._s(_vm.s.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Аннотация\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.anno),
      expression: "s.anno"
    }],
    attrs: {
      "type": "text",
      "maxlength": "170",
      "rows": "3",
      "placeholder": _vm.p.anno
    },
    domProps: {
      "value": _vm._s(_vm.s.anno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.anno = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "flex-wrap": "wrap"
    }
  }, [_c('div', [_c('label', [_vm._v("\n            Дата\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.date),
      expression: "s.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm._s(_vm.s.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.date = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n            Время\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.time),
      expression: "s.time"
    }],
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": _vm._s(_vm.s.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.time = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Место\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.place),
      expression: "s.place"
    }],
    attrs: {
      "type": "text",
      "placeholder": "211"
    },
    domProps: {
      "value": _vm._s(_vm.s.place)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.place = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Цветовая схема\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.theme),
      expression: "s.theme"
    }],
    on: {
      "change": function($event) {
        _vm.s.theme = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "textContent": _vm._s('default')
    }
  }), _vm._v(" "), _vm._l((['gray', 'blue', 'green', 'orange', 'yellow', 'violet']), function(t) {
    return _c('option', {
      domProps: {
        "textContent": _vm._s(t)
      }
    })
  })], 2)])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n          Ссылка\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.url),
      expression: "s.url"
    }],
    attrs: {
      "placeholder": _vm.event.title,
      "type": "url",
      "inputmode": "url"
    },
    domProps: {
      "value": _vm._s(_vm.s.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#f7f7f7",
      "font-size": "0.8em",
      "padding": "0 0.3em",
      "color": "#0d47a1"
    }
  }, [_vm._v("\n          meetups.sfedu.ru/" + _vm._s(_vm.link))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('event', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "e": _vm.event
    }
  })], 1)]), _vm._v("\n\n  Текст на отдельной странице\n  "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('label', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s.text),
      expression: "s.text"
    }],
    ref: "text",
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.p.text
    },
    domProps: {
      "value": _vm._s(_vm.s.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.s.text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('extended', {
    ref: "preview",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "e": _vm.event,
      "header": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "create"
  }, [_c('label', {
    attrs: {
      "for": "pass"
    }
  }, [_vm._v("Пароль:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticStyle: {
      "width": "11em"
    },
    attrs: {
      "id": "pass",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm._s(_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "okay",
    attrs: {
      "type": "submit",
      "value": "Создать"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('h3', [_vm._v("Какую проблему решает этот сайт?")]), _vm._v("\n\n  Здесь собраны все семинары, митапы и классные события,\n  которые происходят на мехмате. Всегда можно заглянуть и найти что-нибудь интересное.\n\n\n  "), _c('h3', [_vm._v("Как можно подписаться?")]), _vm._v("\n\n  Пока что у нас есть канал в телеграмме\n  "), _c('a', {
    attrs: {
      "href": "https://t.me/mmcs_meetups"
    }
  }, [_vm._v("@mmcs_meetups")]), _vm._v(",\n  новости в нём появляются при анонсе мероприятия и повторно за 4 часа.\n  Скоро сделаем твиттер-аккаунт и паблик вконтакте.\n\n\n  "), _c('h3', [_vm._v("Как добавить событие?")]), _vm._v("\n\n  На данный момент доступ к админке имеют только\n  "), _c('u', {
    attrs: {
      "title": "организаторы мероприятий"
    }
  }, [_vm._v("доверенные")]), _vm._v(" лица.\n  Можно написать на почту (контакты ниже), и мы сами опубликуем мероприятие.\n\n\n  "), _c('h3', [_vm._v("Могу я помочь проекту?")]), _vm._v(" "), _c('p', [_vm._v("Конечно! Расскажи о сайте своим друзьям, студентам или преподавателям.\n\n  ")]), _vm._m(0), _c('h3', {
    staticStyle: {
      "margin-top": "2.5em"
    }
  }, [_vm._v("Контакты")]), _vm._v(" "), _vm._l((_vm.contacts), function(p, i) {
    return _c('p', [_vm._v("\n    " + _vm._s(p.name) + " — " + _vm._s(p.about) + " \n\n    "), _c('span', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('a', {
      attrs: {
        "href": p.vk
      }
    }, [_vm._v("vk")]), _vm._v(" /\n      "), _c('a', {
      attrs: {
        "href": _vm.emails[i].href,
        "onclick": _vm.emails[i].click
      }
    }, [_vm._v("email")])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Программируешь? Попробуй написать бота для twitter или vk,\n  нарисовать классную статистику на "), _c('em', [_vm._v("d3.js")]), _vm._v(", или решить проблему\n  из "), _c('a', {
    attrs: {
      "href": "https://github.com/xamgore/mmcs-meetups/issues"
    }
  }, [_vm._v("списка в репозитории")]), _vm._v(".\n\n  Если сомневаешься в своих способностях, не переживай, мы поможем.\n\n\n  ")])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.toggleText
    }
  }, [_c('p', {
    class: ['prelude', {
      offerMoreText: _vm.offerMoreText
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.crop && _vm.expanded && _vm.text) ? _c('p', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('event', {
    attrs: {
      "e": _vm.e
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.authors), function(a) {
    return _c('div', {
      staticClass: "author"
    }, [_c('div', {
      staticClass: "ava",
      style: ({
        'background-image': _vm.url(a.ava)
      })
    }, [_c('img', {
      attrs: {
        "src": a.ava,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(a.name)
      }
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author"
  }, [_vm._l(((_vm.expand ? _vm.all : _vm.left)), function(a) {
    return _c('div', {
      class: ['ava', {
        squeeze: _vm.expand
      }],
      style: ({
        'background-image': _vm.url(a.ava)
      }),
      attrs: {
        "title": a.name
      }
    })
  }), _vm._v(" "), (!_vm.expand) ? _c('span', {
    staticClass: "more"
  }, [_vm._v("\n    и "), _c('a', {
    on: {
      "click": function($event) {
        _vm.expand = true
      }
    }
  }, [_vm._v("ещё " + _vm._s(_vm.rightCount))])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [_vm.e.theme]
  }, [(_vm.header) ? _c('header', [_c('e-title', {
    attrs: {
      "e": _vm.e,
      "extended": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('e-content', {
    attrs: {
      "text": _vm.text
    }
  }), _vm._v(" "), _c('footer', [(_vm.e.authors) ? [_c('h5', [_vm._v(_vm._s(_vm.e.authors.length == 0 ? 'Докладчик:' : 'Докладчики:'))]), _vm._v(" "), _c('e-authors', {
    attrs: {
      "authors": _vm.e.authors
    }
  })] : _vm._e(), _vm._v(" "), (_vm.e.attendees) ? [_c('h5', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Придут:")]), _vm._v(" "), _c('e-attendees', {
    attrs: {
      "attendees": _vm.e.attendees
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(59);




new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  data: { theme: '' },
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  created: function created() {
    var _this = this;

    this.$router.afterEach(function (to, from) {
      _this.$root.theme = '';
    });
  }
});

/***/ })
]),[167]);


// WEBPACK FOOTER //
// static/js/app.ae607c1c0f247a470c3e.js